// Reinforce's own visual system: warm paper, hard black outlines, solid offset
// shadows, and flat blocks of colour. Nothing here is shared with the other
// brands — that separation is the point.
export const rf = {
  // Surfaces
  cream: "#F9E7D8",
  creamDeep: "#F2D9C6",
  paper: "#FFFFFF",

  // Ink
  ink: "#141414",
  inkSoft: "#57514C",
  inkFaint: "#8A817A",

  // Flat accents
  coral: "#FF5C4D",
  coralDeep: "#E5412F",
  amber: "#FFB426",
  mint: "#8ED081",
  sky: "#9CC9F5",
  lilac: "#C7B4F2",

  // The look: a real border and a shadow with no blur in it.
  line: "2.5px solid #141414",
  lineThin: "2px solid #141414",
  shadowSm: "3px 3px 0 #141414",
  shadow: "6px 6px 0 #141414",
  shadowLg: "10px 10px 0 #141414",

  radius: "18px",
  radiusSm: "12px",
  radiusPill: "999px",

  display: "'Outfit', 'Be Vietnam Pro', system-ui, sans-serif",
  body: "'Be Vietnam Pro', system-ui, sans-serif",

  // Faint graph-paper grid, laid under the whole page.
  grid: `linear-gradient(rgba(20,20,20,0.045) 1px, transparent 1px),
         linear-gradient(90deg, rgba(20,20,20,0.045) 1px, transparent 1px)`,
  gridSize: "44px 44px",
};

// A cohort is only ever one of two things: taking registrations, or running
// with registrations closed. Status colour is a flat fill, not a tint.
export const STATUS_FILL = {
  open: rf.mint,
  in_progress: rf.creamDeep,
};

export default rf;
